export const placeOfBirthValidationPattern = /^(?![-.])([\p{Script=Latin}\p{Zs}\-.]*[\p{Script=Latin}\p{Zs}])$/u
